export default function ScoreCupIco() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 1H11V0.5C11 0.2 10.8 0 10.5 0H3.5C3.2 0 3 0.2 3 0.5V1H0.5C0.2 1 0 1.2 0 1.5V2.85C0 5.05 1.7 6.85 3.9 6.95C4.3 7.5 4.85 7.9 5.5 8.15V9.5H5C4.15 9.5 3.5 10.15 3.5 11V12.5C3.5 12.8 3.7 13 4 13H10C10.3 13 10.5 12.8 10.5 12.5V11C10.5 10.15 9.85 9.5 9 9.5H8.5V8.2C9.15 7.95 9.7 7.5 10.1 7C12.25 6.85 14 5.1 14 2.9V1.5C14 1.2 13.8 1 13.5 1ZM1 2.85V2H3V4.5C3 5 3.1 5.45 3.25 5.85C1.95 5.5 1 4.3 1 2.85ZM13 2.85C13 4.25 12.05 5.45 10.75 5.85C10.9 5.45 11 5 11 4.5V2H13V2.85Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
